// removed by extract-text-webpack-plugin
module.exports = {"header-bar-container":"header-bar__header-bar-container__1nXDI","header-bar-nav":"header-bar__header-bar-nav__1B80V","header-title":"header-bar__header-title__DEb2o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/HeaderBar/header-bar.scss
// module id = 1727
// module chunks = 1